import cookies from '../../../utils/cookies';
import { headers } from '../../../maps/common';
import Auth from './auth/auth';
import { destroyUser } from './logout';

let controller = new AbortController();

export const scanUser = async () => {
  let result = false;
  if (cookies.get('token')) {
    controller.abort();
    controller = new AbortController();
    const response = await fetch('https://integration.forstok.com/dashboard_user', {
      method: 'GET',
      headers: headers('application/json')
    });
    const res = await response.json();
    result = res.success;
    if (!result) {
      destroyUser();
    } else {
      Auth.login();
    }
  }
  return result;
}